import { BasicInput, Row } from '@elotech/components';
import React from 'react';

import { useCamposLocalizacao } from '../../hooks/useCamposLocalizacao';
import {
  CampoLocalizacao,
  getCamposLocalizacaoRural
} from '../../utils/InscricaoCadastralUtils';

type Props = {
  /** Campos de localização já carregados pela tela; sem eles, o componente carrega a configuração. */
  camposLocalizacao?: CampoLocalizacao[];
};

const PropriedadeFormRural: React.FC<Props> = ({ camposLocalizacao }) => {
  const camposRurais = getCamposLocalizacaoRural(
    useCamposLocalizacao(camposLocalizacao)
  );

  return (
    <>
      <Row>
        <BasicInput
          size={4}
          name={'cadastroRural.nome'}
          label={'Nome'}
          disabled
        />
        <BasicInput
          size={5}
          name={'cadastroRural.enderecoDescrito'}
          label={'Endereço Descrito'}
          disabled
        />
      </Row>
      <Row>
        <BasicInput
          size={4}
          name={'cadastroRural.logradouro'}
          label={'Logradouro'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroRural.bairro'}
          label={'Bairro'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroRural.complemento'}
          label={'Complemento'}
          disabled
        />
        {camposRurais.map(({ campo, label, campoCadastro }) => (
          <BasicInput
            key={campo}
            size={2}
            name={`cadastroRural.${campoCadastro}`}
            label={label}
            disabled
          />
        ))}
      </Row>
      <Row>
        <BasicInput
          size={2}
          name={'cadastroRural.numeroReceita'}
          label={'NIRF'}
          hint={'Número do Imóvel na Receita Federal'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroRural.numeroIncra'}
          label={'Número no INCRA'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroRural.alqueires'}
          label={'Qtd. Alqueires'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroRural.hectares'}
          label={'Qtd. Hectares'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroRural.areaTotal'}
          label={'Área total'}
          disabled
        />
      </Row>
    </>
  );
};

export default PropriedadeFormRural;
